export const profileSettingsES = {
  'Database Security Settings': 'Database Security Settings',
  Cancel: 'Cancel',
  'Loading': 'Loading...',
  Save: 'Save',
  'User Security Settings': 'User Security Settings',
  'Lock Inactive Users After:': 'Lock Inactive Users After:',
  Days: 'Days',
  'Password Expire After:': 'Password Expire After:',
  'Archive the previous:': 'Archive the previous:',
  'Passwords': 'Passwords',
  'Minimum password length:': 'Minimum password length:',
  Characters: 'Characters',
  'Class Name': 'Class Name',
  'Add Fold?': 'Add Fold?',
  'Del Fold?': 'Del Fold?',
  'Modify Fold?': 'Modify Fold?',
  'Add D Fold?': 'Add D Fold?',
  'Del D Fold?': 'Del D Fold?',
  'Modify D Fold?': 'Modify D Fold?',
  'Folder Security Settings': 'Folder Security Settings',
  'Duplicate Pedigrees': 'Duplicate Pedigrees',
  'Duplicate Individuals': 'Duplicate Individuals',
  'Database Options': 'Database Options',
  'Force Pedigree Name to be Unique': 'Force Pedigree Name to be Unique',
  'Force Individual Name to be Unique': 'Force Individual Name to be Unique',
  Ok: 'Ok',
  'Information Message': 'Information Message',
  'Database Security Settings Saved': 'Database Security Settings Saved',
  'The minimum password length must be at least 8': 'The minimum password length must be at least 8',
  'Operation Canceled': 'Operation Canceled',
  'Individual Name': 'Individual Name',
  'Pedigree Name': 'Pedigree Name',
  'Folder Path': 'Folder Path',
  'Warning': 'Warning',
  'Failed to save data': 'Failed to save data',
};